import { NavLink } from "react-router-dom";
import { cn } from "./ui/cn";
import { useTranslation } from "react-i18next";
import { useHolyMode } from "@/preferences/holy-mode";
import { SacredIcon } from "./sacred-icon";
import { BookOpen, Building2 } from "lucide-react";

const links = [
  { to: "/", key: "nav.policies", end: true, icon: "book" as const },
  { to: "/domains", key: "nav.domains", end: false, icon: "church" as const },
];

export function NavLinks() {
  const { t } = useTranslation();
  const { enabled } = useHolyMode();
  return (
    <nav className="bible-app-nav flex items-center gap-1" aria-label={t("nav.main")}>
      {links.map((l) => (
        <NavLink
          key={l.to}
          to={l.to}
          end={l.end}
          className={({ isActive }) =>
            cn(
              "rounded-md px-3 py-1.5 text-sm font-medium transition-colors",
              isActive ? "bg-accent-soft text-foreground" : "text-secondary hover:bg-surface-sunken",
            )
          }
        >
          {enabled ? <SacredIcon name={l.icon} size={17} /> : null}
          {!enabled ? <span className="bible-app-nav__compact-icon" aria-hidden="true">{l.icon === "book" ? <BookOpen size={17} /> : <Building2 size={17} />}</span> : null}
          <span className="bible-app-nav__label">{t(l.key)}</span>
        </NavLink>
      ))}
    </nav>
  );
}
